import { InAppBrowser } from "@ionic-native/in-app-browser";

type BrowserTarget = "_system" | "_blank" | "_self";

export function openBrowser(url: string, target: BrowserTarget = "_system") {
  InAppBrowser.create(url, target);
}
